import Footer from "./footer/Footer";
import HomePageLinkFooter from "./footer/HomePageLinkFooter";
import NewFooter from "./footer/NewFooter";
import Partners from "./Partners";

const PageFooter = ({
  showPartners = true,
  partnersTitle,
  partnersDescription,
}) => {
  return (
    <>
      {/* {showPartners && (
        <section id="our-partners" className="our-partners">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 offset-lg-3">
                <div className="main-title text-center">
                  {partnersTitle && <h2>{partnersTitle}</h2>}
                  {partnersDescription && <p>{partnersDescription}</p>}
                </div>
              </div>
            </div>
            <div className="row">
              <Partners />
            </div>
          </div>
        </section>
      )} */}
      {/* {showPartners && (
        <section
          id="our-partners"
          className="our-partners py-3 py-md-4 py-lg-5"
        >
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                <div className="main-title text-center mb-3 mb-md-4">
                  {partnersTitle && (
                    <h2 className="partners-title">{partnersTitle}</h2>
                  )}
                  {partnersDescription && (
                    <p className="partners-description">
                      {partnersDescription}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Partners />
              </div>
            </div>
          </div>
        </section>
      )} */}

      <section className="py-0 home-container">
        <HomePageLinkFooter />
      </section>

      <section className="footer_one py-0 home6 bg-ptrn2">
        <div className="container-fluid  main_footer">
          {/* <div className="row"> */}
            {/* <Footer /> */}
            <NewFooter />
          {/* </div> */}
        </div>
      </section>

      {/* <section className="footer_middle_area home6 pt30 pb30">
        <div className="container">
          <CopyrightFooter data={footerCmsData} />
        </div>
      </section> */}
    </>
  );
};

export default PageFooter;
